import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";

const UpdateCompanyYard = ({
  selectedRowsData,
  updateHandleChange,
  getData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const companyName = selectedRowsData.company?.company_name || "";
  const companyLocation = selectedRowsData.company?.location || "";
  const companyId = selectedRowsData.company?.id || "";
  const rawMaterialId = selectedRowsData.rawMaterialName?.id || "";

  const updateData = async (e) => {

    const closeModal = () => {
      $(".custon-close-button-color").trigger("click");
    };
    e.preventDefault();
    const { id, company_id, yard_name } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/com-yard/company-yards/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_id: companyId,
        yard_name,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <div
      className="modal custom-modal fade"
      id="editModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Update Company Yard
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  {/* <h4 className="card-title">Update Party Name</h4> */}
                  <form className="form-sample" onSubmit={updateData}>
                    {/* <p className="card-description">Personal info</p> */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="yard">Yard Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="yard_name"
                            id="yard"
                            placeholder="Yard Name"
                            onChange={updateHandleChange}
                            value={selectedRowsData.yard_name}
                            required
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="company_name">Company Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="material_name"
                            id="company_name"
                            placeholder="Company Name"
                            readOnly
                            value={`${companyName}, ${companyLocation}`}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary mr-2 mt-3"
                      type="submit"
                      // onClick={updateData}
                    >
                      Update
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateCompanyYard;
